/**
 * งวดเดือน (YYYY-MM) — ใช้ร่วมกันกับตัวกรองเดือนของหน้าต่างๆ (เช่น "กิจกรรมผิดปกติ").
 * ปีที่โชว์เป็น พ.ศ. อัตโนมัติเพราะ locale 'th-TH' ของ Intl คำนวณปีพุทธศักราชให้เอง.
 */

/**
 * งวดปัจจุบัน "YYYY-MM" — ตัวเลข/ป้ายเตือนที่โชว์แบบ "ตอนนี้มีอะไรค้าง" ทุกจุด
 * ต้องผูกกับงวดนี้ ไม่ใช่ยอดสะสมทุกเดือน (ของค้างข้ามเดือนที่ปิดงวดไปแล้วแก้ไม่ได้
 * ทำให้ตัวเลขบนเมนู/แดชบอร์ดพองจนไม่มีใครกดดู)
 */
export function currentPeriod(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** 6 งวดล่าสุดย้อนจากเดือนปัจจุบัน เรียงใหม่→เก่า เช่น ['2026-07', '2026-06', ...] */
export function getLast6Periods(): string[] {
  const periods: string[] = [];
  const d = new Date();
  for (let i = 0; i < 6; i++) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    periods.push(`${y}-${m}`);
    d.setMonth(d.getMonth() - 1);
  }
  return periods;
}

/** ชื่อเดือนย่อ + ปี พ.ศ. เช่น "ก.ค. 2569" */
export function periodLabelShort(period: string): string {
  const y = Number(period.slice(0, 4));
  const m = Number(period.slice(5, 7));
  return new Date(y, m - 1, 1).toLocaleDateString('th-TH', { month: 'short', year: 'numeric' });
}
